import * as React from 'react';

const ReviewStarUnfilled = ({
  height = '18px',
  width = '18px',
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    height={height}
    viewBox="0 0 18 18"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#B2B2B2"
      fillRule="evenodd"
      d="m9 14.36-5.29 2.78 1.01-5.89L.44 7.08l5.91-.86L9 .86l2.64 5.36 5.92.86-4.28 4.17 1.01 5.9L9 14.34Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ReviewStarUnfilled;
